/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const scheduleSlotSchema = z.object({
	day: z.number(),
	start: z.string(),
	end: z.string(),
})

export type ScheduleSlotSchema = z.infer<typeof scheduleSlotSchema>
